var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadTemplate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1966_429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.986 16.2885V8.66758C23.986 5.37773 26.6528 2.71094 29.9427 2.71094H92.4872C95.7771 2.71094 98.4438 5.37773 98.4438 8.66758V72.6973C98.4438 73.5629 98.2571 74.4107 97.9038 75.1832C97.612 75.8324 97.2009 76.4301 96.6886 76.9443L77.0774 96.641C76.5612 97.1592 75.9636 97.5723 75.3122 97.8682C74.5339 98.2256 73.6821 98.4143 72.8104 98.4143H29.9743C26.6665 98.4143 23.9858 95.7338 23.9858 92.4258V64.8566",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9036 75.1836H75.312V97.8684",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6306 16.8086H2.74072V63.2689H84.6306V16.8086Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1431 28.7227V51.3373C40.3933 51.3803 48.0687 51.3373 48.0687 51.3373",
    stroke: "#33CCCC",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8848 31.0493C71.8848 31.0493 67.8234 27.6355 63.034 29.0782C58.6363 30.403 58.0213 35.4737 61.2027 37.548C61.2027 37.548 64.3246 38.9407 67.7873 40.2181C76.1227 43.2927 72.532 51.3566 65.8219 51.3566C62.4617 51.3566 59.6414 49.8851 57.9346 48.0015",
    stroke: "#33CCCC",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8242 28.7227L28.2299 51.3564",
    stroke: "#33CCCC",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1154 28.7227L14.6895 51.3564",
    stroke: "#33CCCC",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1966_429"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(0.592285 0.5625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadTemplate);
export default __webpack_public_path__ + "static/media/download_template.57374dab06175d39f177b8f31ff9b8a2.svg";
export { ForwardRef as ReactComponent };